import React from "react";

import { Box, Typography } from "@mui/material";
import { Button } from "Components/Form";
import { Color } from "Components/Form/Button";
import { Add as IconAdd } from "iconsax-react";
import { useTranslation } from "react-i18next";

import useStyles from "./styles";

const noUserLogo = require("Assets/img/noUserLogo.png");

interface EmptyStateProps {
  buttonResource: string;
  descriptionResource: string;
  onAddNew?: () => void;
}

export const EmptyState = ({ buttonResource, descriptionResource, onAddNew }: EmptyStateProps) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  return (
    <Box display="flex" flexDirection="column" alignItems="center" padding="32px 0px">
      <Box className={classes.accUserLogo}>
        <img src={noUserLogo} alt="noUserLogo" className={classes.accUserLogoImg} />
      </Box>
      <Typography className={classes.noMemberHeading}>
        {translate("itLooksLikeThereSNoDataYet")}
      </Typography>
      <Typography className={classes.noMemberSubheading}>
        {`${translate(
          "youWillBeAbleToSeeAllTheInformationAboutThe"
        )} ${descriptionResource} ${translate("associatedWithThisEquipmentWhenTheyAreAdded")}`}
      </Typography>
      {onAddNew && (
        <Button
          customColor={Color.SECONDARY_DARK}
          onClick={onAddNew}
          startIcon={<IconAdd size={20} />}
        >
          {buttonResource}
        </Button>
      )}
    </Box>
  );
};
